import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useSearchParams } from "react-router-dom";
import Wallet from "../wallet";
import { useState } from "react";
import { saveData, type WalletDetails } from "@/shared";

const ImportWallet = () => {
	const [searchParams] = useSearchParams();
	const chainParam = searchParams.get("chain") || "solana";
	const chain = chainParam === "ethereum" ? "ethereum" : "solana";
	const [name, setName] = useState("");
	const [seed, setSeed] = useState("");
	const [mnemonic, setMnemonic] = useState<string>("");

	const handleImportWallet = () => {
		if (!chain) return;

		const importedMnemonic = seed.trim();
		const words = importedMnemonic.split(/\s+/);

		if (words.length !== 12 && words.length !== 24) {
			alert("Please enter a valid 12 or 24-word recovery phrase.");
			return;
		}

		const isValid = Wallet.validate(importedMnemonic);

		if (!isValid) {
			alert("Invalid recovery phrase. Please check and try again.");
			return;
		}

		if (mnemonic && mnemonic !== importedMnemonic) {
			if (
				!confirm(
					"This will replace your existing recovery phrase. All current wallets will be removed. Continue?",
				)
			) {
				return;
			}
		}

		const wallet = new Wallet(chain, 0);
		const { publicKey, privateKey } = wallet.importWallet(importedMnemonic);

		const walletName = name.trim() || `${chain.charAt(0).toUpperCase() + chain.slice(1)} Wallet 1`;

		const newWallet: WalletDetails = {
			type: chain,
			name: walletName,
			publicKey,
			privateKey,
		};

		setMnemonic(importedMnemonic);
		const updatedWallets = [newWallet];
		saveData(importedMnemonic, updatedWallets);
		setName("");
		setSeed("");
		window.location.href = "/dashboard";
	};

	return (
		<section className="flex-1 flex items-center justify-center px-6">
			<Card className="w-full max-w-lg bg-neutral-950 border-neutral-800">
				<CardHeader>
					<CardTitle className="text-2xl text-white">Import Wallet</CardTitle>
					<CardDescription className="text-neutral-500">
						Enter your 12 or 24-word recovery phrase to import your {chain} wallet.
					</CardDescription>
				</CardHeader>
				<CardContent className="space-y-4">
					<div>
						<Input
							placeholder="Wallet name (optional)"
							type="text"
							value={name}
							onChange={(e) => setName(e.target.value)}
							className="h-12 bg-neutral-900 border-neutral-800 text-white placeholder:text-neutral-600 focus-visible:ring-white/20 rounded-xl"
						/>
					</div>
					<div>
						<textarea
							placeholder="Enter your secret recovery phrase (12 or 24 words separated by spaces)"
							value={seed}
							onChange={(e) => setSeed(e.target.value)}
							rows={4}
							className="w-full h-32 px-4 py-3 bg-neutral-900 border border-neutral-800 text-white placeholder:text-neutral-600 rounded-xl resize-none focus:outline-none focus:ring-2 focus:ring-white/20"
						/>
					</div>
					<Button
						onClick={handleImportWallet}
						disabled={!seed.trim()}
						className="w-full h-12 bg-white hover:bg-neutral-200 text-black font-semibold rounded-xl disabled:opacity-50 disabled:bg-neutral-800 disabled:text-neutral-500"
					>
						Import Wallet
					</Button>
				</CardContent>
			</Card>
		</section>
	);
};

export default ImportWallet;
